import { render, staticRenderFns } from "./XButton.vue?vue&type=template&id=65d82d1f&scoped=true"
import script from "./XButton.vue?vue&type=script&lang=js"
export * from "./XButton.vue?vue&type=script&lang=js"
import style0 from "./XButton.vue?vue&type=style&index=0&id=65d82d1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d82d1f",
  null
  
)

export default component.exports